import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import {
  APPLE_APP_STORE_LOGO,
  GOOGLE_PLAY_LOGO,
} from '../../config/constants/images';
import {
  LINK_APPLE_APP_STORE,
  LINK_GOOGLE_PLAY_STORE,
} from '../../config/links/links';
import {
  APPLE_APP_STORE_ARIA_LABEL,
  GOOGLE_PLAY_ARIA_LABEL,
} from '../../config/text/text';
import DownloadAppLink from './DownloadAppLink';

const DownloadAppLinks = ({ site, inline }) => {
  return (
    <>
      <div
        className={classNames('download-links', {
          'download-links--inline': inline,
        })}
      >
        <DownloadAppLink
          alt={APPLE_APP_STORE_ARIA_LABEL}
          ariaLabel={APPLE_APP_STORE_ARIA_LABEL}
          href={LINK_APPLE_APP_STORE[site]}
          inline={inline}
          src={APPLE_APP_STORE_LOGO}
        />
        <DownloadAppLink
          alt={GOOGLE_PLAY_ARIA_LABEL}
          ariaLabel={GOOGLE_PLAY_ARIA_LABEL}
          href={LINK_GOOGLE_PLAY_STORE[site]}
          inline={inline}
          src={GOOGLE_PLAY_LOGO}
        />
      </div>
      <style>{`
    .download-links--inline {
      position: relative;
      width: 100%;
      display: flex;
      justify-content: space-between;
      margin-top: 10px;
    }
    `}</style>
    </>
  );
};

DownloadAppLinks.propTypes = {
  site: PropTypes.string.isRequired,
};

export default DownloadAppLinks;
